import * as ajax from './fetch'

(function() {
    'use strict'
    const public_key = 'BGwxJiViuDUWJLhVnv3bV5TVrKJ-lrmmnyw7HXagjIJUbCDQanK7-tKgdo5lb4gIbNBz4cjDpAaU6pzrUE3quKg'

    const urlBase64ToUint8Array = (value) => {
        const padding = '='.repeat((4 - (value.length % 4)) % 4)
        const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/')
        const rawData = atob(base64)
        return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)))
    }

    document.addEventListener( 'DOMContentLoaded', () => {
        if ( document.querySelector( '#send_notification' ) ) {
            const sendButton = document.querySelector( '#send_notification' )

            sendButton.addEventListener( 'click', ( ev ) => {
                sendNotification().then(
                    ( data ) => {
                        console.log( data )
                    },
                    ( error ) => {

                    }
                )
            })
        }

        console.log(Notification.permission)

        let sendNotification = async () => {
            return new Promise( ( resolve, reject ) => {
                /* Send subscription to backend */
                let params = {
                        action: 'meinefreikarte_send_notification',
                        _ajax_nonce: meinefreikarte.security
                    },
                    options = {
                        body: params
                    }
                ajax.post(
                    meinefreikarte.url,
                    options
                ).then((content) => {
                    console.log(content)
                    resolve( content )
                })
            })
        }

        if ( document.querySelector( '.module-pwa' ) ) {
            let installPrompt = null
            const pwaContainer = document.querySelector( '.module-pwa')
            const installButton = document.querySelector('.module-pwa a.button')
            
            window.addEventListener('beforeinstallprompt', ( event ) => {
                event.preventDefault()
                installPrompt = event
                pwaContainer.classList.remove( 'is-hidden' )
            })
    
            installButton.addEventListener('click', async ( ev ) => {
                ev.preventDefault()
                if ( !installPrompt ) {
                    return
                }
                
                const result = installPrompt.prompt().then( ( data ) => {
                    if ( data.outcome == 'accepted' ) {
                        installPrompt = null
                        pwaContainer.remove()   
                    }
                })
            })
    
            let registerServiceWorker = () => {
                    if ( 'serviceWorker' in navigator) {
                        navigator.serviceWorker.register('/service-worker.js').then(
                            (registration) => {
                                console.log('Service worker registered successfully:', registration)
                            },
                            (error) => {
                                console.error(`Service worker registration failed: ${error}`)
                            }
                        )
                    }
                }
        }

        if ( document.querySelector( '.module-notifications' ) ) {
            const notificationsContainer = document.querySelector( '.module-notifications' )
            const notPermButton = document.querySelector( '.module-notifications a.button' )

            notPermButton.addEventListener( 'click', ( ev ) => {
                ev.preventDefault()

                let clickedElem = ev.target

                clickedElem.classList.add( 'is-loading' )

                handle_notification_process().then( 
                    ( subscription ) => {
                        console.log( subscription )
                        clickedElem.classList.remove( 'is-loading' )
                        
                        if ( subscription != null ) {
                            notificationsContainer.querySelector( '.content > .text ' ).remove()
                            notificationsContainer.querySelector( '.content > .success_text ' ).classList.add( 'is-active' )
                            notPermButton.remove()
                        }
                    },
                    ( error ) => {
                        clickedElem.classList.remove( 'is-loading' )
                    }
                )
            })

            let get_subscription = async () => {
                    return new Promise( ( resolve, reject ) => {
                        let registration = navigator.serviceWorker.ready.then( ( service_worker ) => {
                            let subscription = service_worker.pushManager.subscribe({
                                userVisibleOnly: true,
                                applicationServerKey: urlBase64ToUint8Array( public_key )
                            }).then( 
                                ( subscription_data ) => {
                                    /* Store as data */
                                    console.log('Push subscription:', subscription_data, subscription_data.toJSON())

                                    /* Send subscription to backend */
                                    let params = {
                                            action: 'meinefreikarte_save_pwa_subscription',
                                            _ajax_nonce: meinefreikarte.security,
                                            subscription: JSON.stringify( subscription_data.toJSON() )
                                        },
                                        options = {
                                            body: params
                                        }

                                    ajax.post(
                                        meinefreikarte.url,
                                        options
                                    ).then((content) => {
                                        console.log(content)
                                        resolve( subscription_data )
                                    })
                                },
                                ( error ) => {
                                    console.log(error)
                                    reject( error )
                                }    
                            )
                        })
                    })
                },
                check_for_notification_support = () => {
                    if ( !( 'Notification' in window ) ) {
                        /* No support for notifications */
                        return false
                    }

                    /* Check for already granted */
                    if ( Notification.permission == 'default' ) {
                        notificationsContainer.classList.add( 'is-active' )
                    }
    
                    /* Return */
                    return Notification.permission
                },
                check_for_active_subscription = async () => {
                    return new Promise( 
                        ( resolve, reject ) => {
                            if ( !( 'Notification' in window ) ) {
                                /* No support for notifications */
                                console.log( 'This browser does not support desktop notification' )
                                reject( new Error( 'This browser does not support notifications' ) )
                            }

                            /* Check for given permission */
                            if (Notification.permission === 'granted') {
                                // Check whether notification permissions have already been granted
                                // if so, create a notification
                                navigator.serviceWorker.ready.then((data) => {
                                    let checkedSubscription = data.pushManager.getSubscription().then( (subscription) => {
                                        if ( subscription == null ) {
                                            /* No push subscription was given - get one */
                                            get_subscription().then( 
                                                ( subscription ) => {
                                                    console.log( 'subscription given', subscription )
                                                    resolve( subscription )
                                                },
                                                ( error ) => {
                                                    console.log( error )
                                                    reject( error )
                                                }
                                            )
                                        } else {
                                            resolve( subscription )
                                        }
                                    })
                                })
                            }
                        }
                    )
                },
                handle_notification_process = async () =>  {
                    return new Promise( 
                        ( resolve, reject ) => {
                            if ( !( 'Notification' in window ) ) {
                                /* No support for notifications */
                                console.log( 'This browser does not support desktop notification' )
                                reject( new Error( 'This browser does not support notifications' ) )
                            } else if (Notification.permission === 'granted') {
                                // Check whether notification permissions have already been granted
                                // if so, create a notification
                                navigator.serviceWorker.ready.then((data) => {
                                    let checkedSubscription = data.pushManager.getSubscription().then( (subscription) => {
                                        console.log(subscription)
                                        if ( subscription == null ) {
                                            /* No push subscription was given - get one */
                                            get_subscription().then( 
                                                ( subscription ) => {
                                                    console.log( 'subscription given', subscription )
                                                    resolve( subscription )
                                                },
                                                ( error ) => {
                                                    console.log( error )
                                                    reject( error )
                                                }
                                            )
                                        } else {
                                            resolve( subscription )
                                        }
                                    })
                                })
                            } else if (Notification.permission !== 'denied') {
                                // We need to ask the user for permission
                                Notification.requestPermission().then((permission) => {
                                    console.log(permission)
                                    // If the user accepts, let's create a notification
                                    if (permission === 'granted') {
                                        get_subscription().then( 
                                            ( subscription ) => {
                                                console.log( 'subscription given', subscription )
                                                resolve( subscription )
                                            },
                                            ( error ) => {
                                                console.log( error )
                                                reject( error )
                                            }
                                        )
                                    }
                                    if (permission === 'default') {
                                        resolve( null )
                                    }
                                })
                            }
                        }
                    )
                }
            
            check_for_active_subscription().then(
                ( subscription ) => {
                    console.log( 'subscription valid', subscription )
                },
                ( error ) => {
                    console.log( error )
                }
            )
            check_for_notification_support()
        }

        let registerServiceWorker = () => {
                if ( 'serviceWorker' in navigator) {
                    navigator.serviceWorker.register('/service-worker.js').then(
                        (registration) => {
                            console.log('Service worker registered successfully:', registration)
                        },
                        (error) => {
                            console.error(`Service worker registration failed: ${error}`)
                        }
                    )
                }
            }

        registerServiceWorker()
    })
})( )